// Status Tags Colors

export enum BooleanStatus {
  WORKING = 1,
  NOT_WORKING = 2,
  BUSY = 3,
}

export const getStatusDeliveryWorkerColor = (status: BooleanStatus) => {
  switch (status) {
    case BooleanStatus.WORKING:
      return "green";
    case BooleanStatus.BUSY:
      return "orange";
    case BooleanStatus.NOT_WORKING:
      return "red";
    default:
      return "red";
  }
};

// Status Boolean stuts
export const getStatusDeliveryWorker = (status: BooleanStatus) => {
  switch (status) {
    case BooleanStatus.WORKING:
      return "working";
    case BooleanStatus.NOT_WORKING:
      return "not_working";
    case BooleanStatus.BUSY:
      return "busy";
    default:
      return "not_working";
  }
};

export enum StatusDriver {
  ACCEPT = 1,
  PENDING = 2,
  HAND_REJECT = 3,
  NOT_RESPOND = 4,
  CONDITIONS_NOT_MET = 5,
}

export const getStatusDeliveryHistoryColor = (status: StatusDriver) => {
  switch (status) {
    case StatusDriver.ACCEPT:
      return "green";
    case StatusDriver.PENDING:
      return "orange";
    case StatusDriver.HAND_REJECT:
      return "red";
    case StatusDriver.NOT_RESPOND:
      return "blue";
    case StatusDriver.CONDITIONS_NOT_MET:
      return "purple";
    default:
      return "red";
  }
};

// Status Boolean stuts
export const getStatusDeliveryHistoryWorker = (status: StatusDriver) => {
  switch (status) {
    case StatusDriver.ACCEPT:
      return "accept";
    case StatusDriver.PENDING:
      return "pending";
    case StatusDriver.HAND_REJECT:
      return "hand_reject";
    case StatusDriver.NOT_RESPOND:
      return "not_respond";
    case StatusDriver.CONDITIONS_NOT_MET:
      return "conditions_not_met";
  }
};

export enum VehicleType {
  WALKING = 1,
  BIKE = 2,
  ELECTRIC_BIKE = 3,
  MOTORCYCLE = 4,
  CAR = 5
}

// Add to your enum file
export const getVehicleIcon = (vehicleType: VehicleType, statusWorker: number): string => {
  const isAvailable = statusWorker === 1;

  switch (vehicleType) {
    case VehicleType.WALKING:
      return isAvailable
        ? "/greenman-removebg-preview.png"
        : "/walkingMan-removebg-preview.png"
        ; // fallback if no red walking image
    case VehicleType.BIKE:
      return isAvailable
        ? "/green-bike-removebg-preview.png"
        : "/red-bike.png";
    case VehicleType.ELECTRIC_BIKE:
      return isAvailable
        ? "/electirc-green-bike-removebg-preview.png"
        : "/electricRed-removebg-preview.png";
    case VehicleType.MOTORCYCLE:
      return isAvailable
        ? "/green-motor-removebg-preview.png"
        : "/red-motor-bike-removebg-preview.png";
    case VehicleType.CAR:
      return isAvailable
        ? "/green-car-removebg-preview.png"
        : "/red-car-removebg-preview.png";
    default:
      return "/red-car-removebg-preview.png";
  }
};


export const getVehicleTypeName = (type: VehicleType) => {
  switch (type) {
    case VehicleType.WALKING: return 'Walking';
    case VehicleType.BIKE: return 'Bike';
    case VehicleType.ELECTRIC_BIKE: return 'E-Bike';
    case VehicleType.MOTORCYCLE: return 'Motorcycle';
    case VehicleType.CAR: return 'Car';
    default: return 'Vehicle';
  }
};

export const getStatusColor = (statusWorker: number) => {
  return statusWorker === 1 ? '#4CAF50' : '#F44336'; // Green/Red
};
export const getVehicleType = (vehicleType: VehicleType) => {
  switch (vehicleType) {
    case VehicleType.WALKING:
      return "walking";
    case VehicleType.BIKE:
      return "bike";
    case VehicleType.ELECTRIC_BIKE:
      return "electricBiker";
    case VehicleType.MOTORCYCLE:
      return "motorcycle";
    case VehicleType.CAR:
      return "car";
    default:
      return "noRide";
  }
};
